// Keys must match SHIFT_CATEGORIES / SURGERY_CATEGORIES in server/models/residentLog.js.
// Order here is the column order of the public residents table.
export const SHIFT_CATEGORIES = [
    { key: "tep", label: "ΤΕΠ" },
    { key: "septic", label: "Σηπτικό" },
    { key: "elective", label: "Τακτικό" },
    { key: "preop", label: "Προεγχειρητικοί" },
    { key: "port", label: "Port" },
];

export const SURGERY_CATEGORIES = [
    { key: "cholecystectomy", label: "Χολή" },
    { key: "hernia", label: "Κήλη" },
    { key: "abscess", label: "Απόστημα" },
    { key: "bowel", label: "Έντερο" },
    { key: "emergency", label: "Επείγον" },
    { key: "other", label: "Άλλο" },
];

export const CATEGORY_LABELS = Object.fromEntries(
    [...SHIFT_CATEGORIES, ...SURGERY_CATEGORIES].map(({ key, label }) => [key, label])
);

// "2026-09-28T00:00:00.000Z" -> "28/09/2026"; dates are stored as UTC midnight
export const formatDate = (iso) => {
    const [year, month, day] = iso.slice(0, 10).split("-");
    return `${day}/${month}/${year}`;
};
